import { get, post, postFormData, put, putFile, urlApiTegra } from "../../../../../service/api";

const url = urlApiTegra;

async function getEletronic(token: string) {
  return get(`${url}/eletronics-inventory`, token);
}

async function getEletronicById(token: string, id: string | number) {
  return get(`${url}/eletronics-inventory/${id}`, token);
}

async function getClientsOfCollaborator(token: string, id: string | number) {
  return get(`${url}/client/userId/${id}`, token);
}

async function postEletronic({ data, file = undefined }, token: string) {
  const body = JSON.stringify(data);
  return postFormData(`${url}/eletronics-inventory`, { body, file }, token);
}

async function putEletronic({ data, file = undefined }, token: string, id: string | number) {
  const body = JSON.stringify(data);
  return putFile(`${url}/eletronics-inventory/${id}`, { body, file }, token);
}

async function getEletronicFilter(token: string, queryString?: string) {
  return get(queryString ? `${urlApiTegra}/eletronics-inventory${queryString}` : `${urlApiTegra}/eletronics-inventory`, token);
}

export { getEletronic, getEletronicById, getClientsOfCollaborator, postEletronic, putEletronic, getEletronicFilter };
